<div fxLayout="row" fxLayoutAlign="space-between" class="div-dialog-title title-modal" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="dialog-title">
    <h2 mat-dialog-title>{{ data.action }}</h2>
  </div>
</div>
<mat-dialog-content class="mat-typography">
   <span [innerHTML]="data.information"></span>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" class="ternary-button" mat-dialog-close>Non</button>
  <button mat-raised-button color="primary" class="primary-button" (click)="close()">Oui</button>
</mat-dialog-actions>
